import ControllerBase from '../../../../global/js/ControllerBase';

interface ComponentRefs {
	productAttributes: 'productAttributes',
	showAttributes: 'showAttributes',
	hideAttributes: 'hideAttributes',
}


export default class ControllerProductGalleryDetails extends ControllerBase<ComponentRefs> {

	private static readonly componentRefs: ComponentRefs = {
		productAttributes: 'productAttributes',
		showAttributes: 'showAttributes',
		hideAttributes: 'hideAttributes'
	}

	private productAttributes: HTMLDivElement | undefined; // only exists if there are attributes
	private showAttributes: HTMLAnchorElement | undefined; // only exists if there are more than 4 rows
	private hideAttributes: HTMLAnchorElement | undefined; // only exists if there are more than 4 rows
	private isShowingAll = false;

	constructor(element: HTMLElement) {
		super(element, [], Object.values(ControllerProductGalleryDetails.componentRefs));


		this.productAttributes = this.$references.productAttributes as HTMLDivElement;
		this.showAttributes = this.$references.showAttributes as HTMLAnchorElement;
		this.hideAttributes = this.$references.hideAttributes as HTMLAnchorElement;

		this.init();
	}

	private init(): void {
		// setup toggle button clicks
		this.observeTogglerClicks();
	}

	private observeTogglerClicks(): void {
		if (this.productAttributes && this.showAttributes && this.hideAttributes) {
			this.showAttributes.addEventListener('click', e => this.toggleClick(e));
			this.hideAttributes.addEventListener('click', e => this.toggleClick(e));
		}
	}

	private toggleClick(event: Event | MouseEvent): void {
		event.preventDefault();
		// toggle the rows
		const attribs = Array.from(
			this.productAttributes?.querySelectorAll<HTMLDivElement>('div.item') || []
		);

		if (this.isShowingAll) {
			// hide all but first 4 rows
			attribs.forEach((r, idx) => {
				idx >= 4 && r.setAttribute('hidden', 'true');
			});
			this.productAttributes?.classList.contains('truncated') ? undefined : this.productAttributes?.classList.add('truncated');
		} else {
			// show all rows
			attribs.forEach(r => {
				r.removeAttribute('hidden');
			});
			this.productAttributes?.classList.remove('truncated');
		}

		this.isShowingAll = !this.isShowingAll;

		if (this.isShowingAll) {
			// hide the show rows button
			this.showAttributes?.setAttribute('hidden', 'true');
			// show the hide rows button
			this.hideAttributes?.removeAttribute('hidden');
		} else {
			// hide the hide rows button
			this.hideAttributes?.setAttribute('hidden', 'true');
			// show the show rows button
			this.showAttributes?.removeAttribute('hidden');
		}
	}


}
